import { render } from "./TheCodesCountMultiplePromocode.vue?vue&type=template&id=5ca5f95e&scoped=true&lang=html"
import script from "./TheCodesCountMultiplePromocode.vue?vue&type=script&lang=js"
export * from "./TheCodesCountMultiplePromocode.vue?vue&type=script&lang=js"

import "./TheCodesCountMultiplePromocode.vue?vue&type=style&index=0&id=5ca5f95e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca5f95e"]])

export default __exports__